<script lang="ts">
  import type { Product } from "../../helpers/types";
  import InputContainer from "../atoms/InputContainer.svelte";
  import Checkbox from "../atoms/Checkbox.svelte";
  import PriceInfo from "../atoms/PriceInfo.svelte";
  import Specification from "../atoms/Specification.svelte";

  interface Props {
    products: Product[];
    selectedProduct: Product | undefined;
    onClick: () => void;
  }

  let { products, selectedProduct = $bindable(), onClick }: Props = $props();
  let selectedFixed: Product | undefined = $state();

  if (selectedProduct && selectedProduct.type == "fixed") {
    selectedFixed = selectedProduct;
  } else {
    selectedFixed = products[0];
  }

  let disabled = $derived(!(selectedProduct && selectedProduct.type == "fixed"));

  const setProduct = (prod: Product) => {
    if (selectedProduct && selectedProduct.id == prod.id) {
      return;
    } else {
      selectedProduct = prod;
    }
  };
</script>

<InputContainer
  {onClick}
  onChange={() => (selectedProduct = selectedFixed)}
  checked={selectedProduct && selectedProduct.type == "fixed"}
>
  <div class="flex flex-col sm:flex-row sm:justify-between">
    <div>
      {#if selectedFixed}
        <div>
          <span class="text-H3 mr-3">{selectedFixed.name}</span>
          {#if selectedFixed.recommended}
            <span class="tape-Green400 text-white text-H6 hidden sm:inline-block"
              >REKOMMENDERAT</span
            >
          {/if}
        </div>
        {#if selectedFixed.purchaseText}
          <div class="hidden md:block mt-2 purchase-text">{@html selectedFixed.purchaseText}</div>
        {/if}
      {/if}
      <div class="w-full hidden mt-2.5 sm:flex flex-wrap text-M">
        {#each products as product}
          <Checkbox
            disabled={selectedFixed && selectedFixed.id == product.id}
            onChange={() => {
              setProduct(product);
            }}
            variant={disabled ? "secondary" : "primary"}
            type={"radio"}
            bind:group={selectedFixed}
            value={product}
            checked={selectedFixed && selectedFixed.id == product.id}
          >
            {product.length} år
          </Checkbox>
        {/each}
      </div>
    </div>
    {#if selectedFixed && selectedFixed.costs}
      <PriceInfo productType="fixed" costs={selectedFixed.costs} />
    {/if}
    <div class="w-full flex text-M sm:hidden justify-around">
      {#each products as product}
        <Checkbox
          size="small"
          variant={disabled ? "secondary" : "primary"}
          disabled={selectedFixed && selectedFixed.id == product.id}
          type={"radio"}
          onChange={() => {
            setProduct(product);
          }}
          bind:group={selectedFixed}
          value={product}
          checked={selectedFixed && selectedFixed.id == product.id}
        >
          {product.length} år
        </Checkbox>
      {/each}
    </div>
  </div>
  {#if selectedFixed}
    <Specification defaultOpen={false} product={selectedFixed} />
  {/if}
</InputContainer>
